export const Errors = {
    selfService: {
        CPF_REQUIRED: 'Ops...CPF inválido. Tente novamente.',
        PASSWORD_REQUIRED: 'Ops...senha inválida. Tente novamente ou clique em "Não consigo acessar"',
        PASSWORD_REQUIRED_CIP: 'Ops...senha inválida. Tente novamente.',
        CIPWITHOUTACCOUNT: 'Algo está errado. Revise seus dados.',
        CPFWITHOUTACCOUNT: 'Algo está errado. Revise seus dados ou tente entrar com a CIP.',
        BIRTHDATE: 'Ops...data de nascimento inválida. Tente novamente.',
        DEFAULT: 'Ocorreu um erro ao fazer seu login. Tente novamente.',
        CIP_REQUIRED: 'Ops...número inválido. Tente novamente.',
    },
}
